module.exports = __webpack_public_path__ + "img/daily_necessities_laundry.c1425699.jpg";